/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-weather-hail': {
    width: 100,
    height: 100,
    viewBox: '0 0 100 100',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M72.997 71.639a2 2 0 110-3.998 2 2 0 010 3.998zm-8.999-6.698V60.56a7.988 7.988 0 004-6.92 8 8 0 00-7.999-7.999c-1.601 0-3.083.48-4.334 1.291-1.231-5.317-5.973-9.29-11.664-9.29-6.627 0-11.999 5.372-11.999 11.998 0 3.55 1.551 6.728 4 8.925v4.916c-4.777-2.768-7.999-7.922-7.999-13.841 0-8.835 7.162-15.997 15.998-15.997 6.004 0 11.229 3.311 13.965 8.203.664-.113 1.337-.205 2.033-.205 6.626 0 11.998 5.372 11.998 11.999 0 5.223-3.342 9.653-7.999 11.301zm-32.995 7.698a2 2 0 110 3.998 2 2 0 010-3.998zm9.998-16.998c0-1.104-.104-2 1-2s1 .896 1 2v23.998h-2a4 4 0 00-3.999-4v-2c1.543 0 2.937.6 3.999 1.557V55.641zM50 69.639c-1.104 0-1-.895-1-2v-7.998c0-1.105-.104-2 1-2s1 .895 1 2v7.998c0 1.105.104 2-1 2zm0 4a2 2 0 110 4 2 2 0 010-4zm7.999-19.998c1.104 0 1 .896 1 2v18.016c1.823-2.434 4.723-4.018 7.999-4.018v2a8 8 0 00-7.999 8h-2c0-.273.02-.541.041-.807-.054-.334-.041-.744-.041-1.193V55.641c0-1.104-.104-2 1-2z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-weather-hail.js